<script>
import {Clock, House, Star, User, Picture, Upload} from "@element-plus/icons-vue";
import {useRoute} from "vue-router";
import Like from "@icon-park/vue-next/lib/icons/Like";

export default {
    name: 'Aside',
    components: {Star, Clock, User, House, Picture, Upload, Like},
    data() {
        return {
            userType: "",
            defaultActive: "/"
        }
    },
    created() {
        this.userType = localStorage.getItem("userType");
        this.defaultActive = "/" + useRoute().path.split("/")[1];
    },
}
</script>

<template>
    <el-col v-if="userType" :span="24" class="scrollbar-hidden">
        <a href="/">
            <el-row style="border-right: 1px solid rgb(220, 223, 230); border-bottom: 1px solid rgb(220, 223, 230);">
                <el-col :span="9" style="text-align: center;">
                    <img alt="课立方" src="@/assets/images/logo.png" style="width: 40px; padding: 9px 0 5px 30px;">
                </el-col>
                <el-col :span="15">
                    <el-text style="font-size: 25px; line-height: 58px; color: black; font-family: '钉钉进步体';">课立方
                    </el-text>
                </el-col>
            </el-row>
            <el-text v-if="userType === 'teacher'"
                     style="font-size: 12px; color: rgb(143,143,143); position: absolute; left: 160px; top: 43px;">教师端
            </el-text>
            <el-text v-if="userType === 'student'"
                     style="font-size: 12px; color: rgb(143,143,143); position: absolute; left: 160px; top: 43px;">学生端
            </el-text>
        </a>
        <el-menu
            v-if="userType === 'student'"
            :default-active="defaultActive"
            :router="true"
            class="el-menu-vertical-demo"
        >
            <el-menu-item index="/">
                <el-icon :size="25">
                    <House/>
                </el-icon>
                <span>全部资源</span>
            </el-menu-item>
            <el-menu-item index="/my_lesson">
                <el-icon :size="25">
                    <User/>
                </el-icon>
                <span>专属资源</span>
            </el-menu-item>
            <el-menu-item index="/study_record">
                <el-icon :size="25">
                    <Clock/>
                </el-icon>
                <span>学习记录</span>
            </el-menu-item>
            <el-menu-item index="/my_like">
                <el-icon :size="25">
                    <Like/>
                </el-icon>
                <span>我的喜欢</span>
            </el-menu-item>
            <el-menu-item index="/my_collection">
                <el-icon :size="25">
                    <Star/>
                </el-icon>
                <span>我的收藏</span>
            </el-menu-item>
        </el-menu>
        <el-menu
            v-if="userType === 'teacher'"
            :default-active="defaultActive"
            :router="true"
            class="el-menu-vertical-demo"
        >
            <el-menu-item index="/">
                <el-icon :size="25">
                    <House/>
                </el-icon>
                <span>全部资源</span>
            </el-menu-item>
            <el-menu-item index="/upload_lesson">
                <el-icon :size="25">
                    <Upload/>
                </el-icon>
                <span>发布资源</span>
            </el-menu-item>
            <el-menu-item index="/my_upload">
                <el-icon :size="25">
                    <User/>
                </el-icon>
                <span>我的发布</span>
            </el-menu-item>
            <el-menu-item index="/picture_repo">
                <el-icon :size="25">
                    <Picture/>
                </el-icon>
                <span>我的图库</span>
            </el-menu-item>
            <el-menu-item index="/my_like">
                <el-icon :size="25">
                    <Like/>
                </el-icon>
                <span>我的喜欢</span>
            </el-menu-item>
            <el-menu-item index="/my_collection">
                <el-icon :size="25">
                    <Star/>
                </el-icon>
                <span>我的收藏</span>
            </el-menu-item>
        </el-menu>
    </el-col>
</template>

<style scoped>
.el-menu {
    height: calc(100vh - 58px - 1px);
}

.el-menu-item .el-icon {
    margin-left: 20px;
    margin-right: 10px;
}

.el-menu-item span {
    font-size: 18px;
}
</style>